export default "__VITE_ASSET__193LsN15__"